// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sFxW","content":"styles_content__2XFZw","tableWrap":"styles_tableWrap__hxFlO"};